// Frontend error reporter — sends JS errors & unhandled rejections to backend log
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

function sendFrontendLog(level, message, source, stack) {
  try {
    const token = localStorage.getItem('ems_token');
    fetch(`${API_URL}/hub/logs/frontend`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify({
        level,
        message: String(message).slice(0, 1000),
        source: source || window.location.pathname,
        stack: stack ? String(stack).slice(0, 2000) : undefined,
        url: window.location.href,
        user_agent: navigator.userAgent,
      }),
    }).catch(() => {}); // fire-and-forget
  } catch {
    // never crash the app due to log reporting
  }
}

export function initFrontendErrorReporter() {
  // Capture unhandled errors
  window.addEventListener('error', (event) => {
    sendFrontendLog(
      'error',
      event.message || 'Unknown error',
      event.filename || 'unknown',
      event.error?.stack,
    );
  });

  // Capture unhandled promise rejections
  // V14.13.8 — Filter benign noise (request-dedupe "Stale request cancelled",
  // expected "Authentication Required" on guest-gated routes, AbortError
  // from React StrictMode double-effects) so the error log isn't drowned in
  // them. These are operational signals, not bugs.
  const SUPPRESSED_REJECTIONS = [
    /^Stale request cancelled/i,
    /^Authentication Required$/i,
    /^AbortError/i,
    /The user aborted a request/i,
  ];
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const msg = reason?.message || String(reason).slice(0, 500);
    if (SUPPRESSED_REJECTIONS.some(rx => rx.test(msg))) {
      // Acknowledge silently so the browser doesn't log "Uncaught (in promise)".
      event.preventDefault();
      return;
    }
    sendFrontendLog(
      'error',
      `Unhandled Promise Rejection: ${msg}`,
      'promise',
      reason?.stack,
    );
  });

  // Capture console.error calls (wrap original)
  const originalError = console.error;
  console.error = (...args) => {
    originalError.apply(console, args);
    const message = args.map(a => {
      if (a instanceof Error) return a.message;
      if (typeof a === 'object') try { return JSON.stringify(a).slice(0, 300); } catch { return String(a); }
      return String(a);
    }).join(' ');
    // Skip React internal errors and noisy warnings
    if (!message.includes('React') && !message.includes('Warning:') && !message.includes('DevTools')) {
      sendFrontendLog('error', message.slice(0, 1000), 'console.error');
    }
  };
}
